import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import APModal from 'components/Modal/APModal';
import InputField from 'components/FormFields/InputField';

const BusinessCategoryModal = ({ open, onClose, onSave, item }) => {
  const [value, setValue] = useState(item?.other_categories);
  const [error, setError] = useState('');
  const [isValueValid, setValueValidation] = useState(true);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (!open) {
      setError('');
      setValue(item?.other_categories);
      setSubmitted(false);
      setValueValidation(true);
    }
  }, [open, item?.other_categories]);

  useEffect(() => {
    if (value) {
      setValueValidation(true);
      setError('');
    }
  }, [value]);

  const handleValidation = () => {
    if (value === '') {
      setValueValidation(false);
      setError('Please add a business category');
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (handleValidation()) {
      setSubmitted(true);
      item.other_categories = value;
      onSave(value);
    }
  };

  if (submitted) {
    return (
      <APModal
        open={open}
        onClose={() => onClose(value) }
        title="Good to know."
        actions={(
          <button
            className="button"
            onClick={() => {
              onClose(value);
            }}
          >
            Got It
          </button>
        )}
      >
        <p>We love getting to know our community. Thanks for letting us know!</p>
      </APModal>
    );
  }
  return (
    <APModal
      open={open}
      onClose={() => onClose(value) }
      name="business-category"
      title="Give us the dish."
      subtitle="Tell us what you do. We'd love to know!"
      errorMsg={error}
      actions={(
        <button
          className="button"
          onClick={handleSubmit}
        >
          Submit
        </button>
      )}
    >
      <InputField
        name="business-category-name"
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          setError('');
          setValueValidation(true);
        }}
        showError={!isValueValid}
      />
    </APModal>
  );
};

BusinessCategoryModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  item: PropTypes.object,
};

export default BusinessCategoryModal;
